import { handleActions } from 'redux-actions';
import {
    setCart, clearCart
} from '../actions/cartActions';

const defaultState = null;

export default handleActions(
    {
        [setCart](state, action) {
            return { ...state, ...action.payload }
        },
        [clearCart]() {
            return { items: [], currency_code: 'USD' }; 
        }
    },
    defaultState,
);
